import gql from 'graphql-tag';

export default gql`
    query GetDriverCompanyGrade($id: Int) {
        getDriverCompanyGrade(id: $id) {
            grade
        }
    }
`;
